import type {TranslationsType} from '@sirius/ui-lib/src/blocks/LocaleBlock/WithTranslation';

export const languageSet: TranslationsType = {
    language: {
        'cpp': {
            ru: {value: 'C++'},
            en: {value: 'C++'}
        },
        'cpp-no-optimization': {
            ru: {value: 'C++'},
            en: {value: 'C++'}
        },
        'csharp': {
            ru: {value: 'C#'},
            en: {value: 'C#'}
        },
        'go': {
            ru: {value: 'Go'},
            en: {value: 'Go'}
        },
        'java': {
            ru: {value: 'Java'},
            en: {value: 'Java'}
        },
        'javascript': {
            ru: {value: 'Javascript'},
            en: {value: 'Javascript'}
        },
        'haskell': {
            ru: {value: 'Haskell'},
            en: {value: 'Haskell'}
        },
        'kotlin': {
            ru: {value: 'Kotlin'},
            en: {value: 'Kotlin'}
        },
        'kumir': {
            ru: {value: 'КуМир'},
            en: {value: 'KuMir'}
        },
        'pascal': {
            ru: {value: 'PascalABC.NET'},
            en: {value: 'PascalABC.NET'}
        },
        'php': {
            ru: {value: 'PHP'},
            en: {value: 'PHP'}
        },
        'python': {
            ru: {value: 'Python'},
            en: {value: 'Python'}
        },
        'python3': {
            ru: {value: 'Python 3'},
            en: {value: 'Python 3'}
        },
        'python3-ds': {
            ru: {value: 'Python 3'},
            en: {value: 'Python 3'}
        },
        'rust': {
            ru: {value: 'Rust'},
            en: {value: 'Rust'}
        },
        'sql': {
            ru: {value: 'SQL'},
            en: {value: 'SQL'}
        },
        '1c': {
            ru: {value: '1С'},
            en: {value: '1C'}
        },
    }
}
